// HOOKS
import { useRef } from "react";

const DEFAULT_CLASSNAMES = {
  th: "relative font-ubuntuBold hover:bg-secondary hover:text-white hover:rounded px-4 py-2",
  container: "hover:cursor-pointer m-auto",
  slider:
    "active:shadow hover:shadow shadow-black active:bg-primary bg-greenGlass hover:bg-primary rounded absolute top-0 right-0 bottom-0 w-2 cursor-col-resize",
};

const ResizableHeader = ({
  sortProps = { sort: "", handleSort: () => {} },
  select = false,
  column = {},
  handleResize = () => {},
  classNames = DEFAULT_CLASSNAMES,
  children,
}) => {
  const thRef = useRef(null);

  const handleMouseDown = (e) => {
    const startX = e.clientX;
    const startWidth = thRef.current.offsetWidth;

    const handleMouseMove = (moveEvent) => {
      const newWidth =
        startWidth + (moveEvent.clientX - startX) - (select ? 45 : 0); // 45 is width of select column
      handleResize(Math.max(newWidth, 20), column.id); // Minimum width
    };

    const handleMouseUp = () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
    };

    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
  };
  return (
    <th ref={thRef} className={classNames?.th || DEFAULT_CLASSNAMES.th}>
      {" "}
      <div
        className={classNames?.container || DEFAULT_CLASSNAMES.container}
        onClick={() => sortProps?.handleSort(column?.id)}
        style={{
          width: `${column?.width || 150}px`,
        }}
      >
        {children}
      </div>
      {column?.resizable && (
        <div
          className={classNames?.slider || DEFAULT_CLASSNAMES.slider}
          onMouseDown={handleMouseDown}
        ></div>
      )}
    </th>
  );
};

export default ResizableHeader;
